import { useEffect, useState } from "react";

const HERO_SHOTS = [
  "/images/photo_1.jpg",
  "/images/photo_3.jpg",
  "/images/photo_2.jpg",
];

const HeroBand = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setActive((a) => (a + 1) % HERO_SHOTS.length), 7000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="absolute bottom-0 left-0 right-0 h-44 md:h-64 overflow-hidden pointer-events-none" aria-hidden="true">
      {HERO_SHOTS.map((src, i) => (
        <img
          key={src}
          src={src}
          alt=""
          className={`kenburns absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-[1600ms] ${
            i === active ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-[#faf8f5] via-[#faf8f5]/35 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-[#2d4a22]/20" />
    </div>
  );
};

const FloatingLeaves = () => (
  <>
    <svg className="leaf-float absolute top-24 right-[12%] w-6 h-6 text-[#2d4a22] pointer-events-none" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M20 4C10 4 4 10 4 20c10 0 16-6 16-16Z" opacity="0.35" />
    </svg>
    <svg className="leaf-float leaf-float-2 absolute top-40 right-[30%] w-4 h-4 text-[#4ade80] pointer-events-none" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M20 4C10 4 4 10 4 20c10 0 16-6 16-16Z" opacity="0.4" />
    </svg>
    <svg className="leaf-float leaf-float-3 absolute top-16 right-[55%] w-5 h-5 text-[#2d4a22] pointer-events-none" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M20 4C10 4 4 10 4 20c10 0 16-6 16-16Z" opacity="0.25" />
    </svg>
  </>
);

export const Hero = () => (
  <section
    id="hero"
    data-testid="hero-section"
    className="relative py-24 md:py-32 pb-56 md:pb-80 bg-[#faf8f5] text-[#1f281e] border-b border-[#2d4a22]/10 overflow-hidden"
  >
    <div
      className="absolute inset-0 opacity-[0.03] d1-drift pointer-events-none"
      style={{ backgroundImage: "radial-gradient(#2d4a22 1.5px, transparent 1.5px)" }}
    />
    <div className="sun-pulse absolute -top-32 -right-32 w-80 h-80 rounded-full bg-[#4ade80]/10 blur-3xl pointer-events-none" />
    <FloatingLeaves />

    <div className="max-w-6xl mx-auto px-6 relative z-10">
      <div className="max-w-4xl">
        <div className="flex items-center gap-3 mb-6 fade-stage-1">
          <span className="h-2 w-2 bg-[#2d4a22]" />
          <span className="font-mono-type text-xs uppercase tracking-[0.18em] text-[#2d4a22] font-semibold">
            Paramount &amp; Greater Los Angeles
          </span>
        </div>

        <h1 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-[80px] uppercase leading-[0.92] text-[#1f281e] mb-8">
          <span className="ln"><span>Living Landscapes</span></span>
          <span className="ln"><span className="text-[#2d4a22]">Built To Endure.</span></span>
        </h1>

        <p className="text-lg md:text-xl text-[#3d4b3b] max-w-xl leading-relaxed mb-10 fade-stage-2">
          Family-owned craftsmanship personally overseen by Juan Sahagun for residential and commercial grounds.
        </p>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 fade-stage-3">
          <a
            href="#contact"
            data-testid="hero-quote-btn"
            className="inline-flex items-center justify-center px-8 py-4 bg-[#2d4a22] text-[#faf8f5] font-semibold text-xs uppercase tracking-[0.16em] hover:bg-[#1a2d14] transition-colors shadow-sm"
          >
            Request Free Quote
          </a>
          <a
            href="tel:+13232204640"
            data-testid="hero-call-btn"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 border border-[#2d4a22] text-[#2d4a22] font-semibold text-xs uppercase tracking-[0.16em] hover:bg-[#2d4a22]/5 transition-colors"
          >
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            <span>+1 (323) 220-4640</span>
          </a>
        </div>
      </div>
    </div>

    <HeroBand />
  </section>
);
